/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SelectSuperstackingPlanRequest} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/superstacking.pb'
import {SelectSuperstackingPlanResponse} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/superstacking.pb'


export const selectSuperstackingPlan = (request: SelectSuperstackingPlanRequest, options?: CashRequestOptions) => post<SelectSuperstackingPlanRequest, SelectSuperstackingPlanResponse>("/cash-app/crypto/invest/select-superstacking-plan", request, {...options, rejectOnError: true })